module.exports = __webpack_public_path__ + "img/117288999_622796868662584_1310515579219017991_n.d368b1eb.jpg";